import React from "react";
import { Link } from "react-router-dom";
import User from './User';
import * as actions from '../Actions';
import Service from '../../service/Service';
const service = new Service();
const dNone = { display: 'none' };

export default function Question({ questions, isLanding, isShowAbuse, checkQId, eleRef, isSimilarQue, isShowReadMore }) {
    
    // if(questions.length == 1){
    // console.log(isSimilarQue);
    // }
    return (
        <div>
            {questions.map((qna, index) =>
                <div key={index} className="question-block" id={`question_${qna.question_id}`} style={checkQId != '' && checkQId == qna.question_id ? dNone : {}}>
                    <div className="expecting-mom R13_9e">
                        {qna.user_description && qna.user_description != '' &&
                            <span className="expecting-due left">{qna.user_description}</span>
                        }
                        {qna.posted_time && qna.posted_time != '' &&
                            <span className="last-online-time right">{qna.posted_time}</span>
                        }
                    </div>
                    <div className="parenting-ques">
                        <a href={service.getRedirectUrl(`/qna/q/${service.replaceSymbols((qna.question_title) + '-' + (qna.question_id))}`)} className="que-container">
                            <span className="M17_42 qmore" id={`moretext_${qna.question_id}`}><span className="M17_9e q-symbol">Q. </span>{qna.question_title}</span>
                        </a>
                        {isShowReadMore &&
                            <div className="readmore_popup que-readmore" data-id={`moretext_${qna.question_id}`}>
                                <div className="readmorelink R14_link" onClick={(e) => actions.readMoreClick(e, `moretext_${qna.question_id}`)}>Read More</div>
                            </div>
                        }
                    </div>
                    {qna.urls && qna.urls.length > 0 && qna.urls.map((url, ui) =>
                        url.type == 'pdf' &&
                        <div className="qna-attachment" key={ui}>
                            <span className="qna-pdf">
                                <a href={url.source} download>
                                    <div data-icon-font="&#xe039;" className="icon"></div>
                                </a>
                            </span>
                        </div>
                    )}
                    {qna.urls && qna.urls.length > 0 && qna.urls.map((url, ui) =>
                        url.type != "pdf" && url.source && url.source != '' &&
                        <div className="qna-img" key={ui}>
                            <img src={url.source.replace("http://", "https://")}/>
                        </div>
                    )}
                    <div className="social-actions">
                        <div className="answer R13_9e mrgright left" onClick={() => actions.openAnswerPopup(qna.question_id, qna.creater_id)} id={isLanding ? "" : "devquesdetails"}><div data-icon-font="H" className={isLanding ? "icon pencil dev_landingPencil" : "icon pencil"}></div>Answer</div>
                        <a href={service.getRedirectUrl(`/qna/q/${service.replaceSymbols((qna.question_title) + '-' + (qna.question_id))}`)}>
                            <div className="answer R13_9e left">
                                <div data-icon-font="&#xe004;" className={(qna.answers && qna.answers.length > 0 && qna.answers.some(el => el.acid == global.userAry['mycid'])) ? "icon is-active" : "icon"}></div>
                                <span>{qna.answer_count}</span>
                            </div>
                        </a>
                        {isShowAbuse && qna.cid !== global.userAry['mycid'] &&
                            <span className={(qna.que_abuse && (qna.que_abuse == 1 || qna.que_abuse != "false")) ? "que_abuse right M13_42 is-active" : "que_abuse right M13_42"} title={(qna.que_abuse && (qna.que_abuse == 1 || qna.que_abuse != "false")) ? "Already Reported as Abuse" : "Report Abuse"}>
                                <span data-icon-font="&#xe002;" className="icon icon3dot" onClick={(e) => actions.showAbuse(e)}></span>
                                {(qna.que_abuse && (qna.que_abuse == 1 || qna.que_abuse != "false")) ?
                                    <div className="abuse-tooltip R13_9e">Already Reported as Abuse</div>
                                    :
                                    <div className="abuse-tooltip quest-abuse R13_9e" onClick={() => actions.saveQueActions((qna.que_abuse && (qna.que_abuse == 1 || qna.que_abuse != "false")) ? 0 : 1, qna.question_id, qna.creater_id, qna.question_title, "abuse", isSimilarQue, eleRef)}>Report Abuse</div>
                                }
                            </span>
                        }
                        <div className="follow-abuse right">
                            <span className={qna.que_follow && qna.que_follow != 'false' ? "unfollowqa left R13_9e" : "followqa followme left R13_9e"} onClick={() => actions.saveQueActions(qna.que_follow && qna.que_follow != 'false' ? 0 : 1, qna.question_id, qna.creater_id, qna.question_title, "follow", isSimilarQue, eleRef)}>
                                {qna.que_follow && qna.que_follow != 'false' ?
                                    `Following | ${qna.follow_count}` :
                                    `+ Follow | ${qna.follow_count}`
                                }
                            </span>
                        </div>
                    </div>
                    {!isSimilarQue && qna.answers && qna.answers.length > 0 && qna.answers.map((answer, ai) =>
                        
                        answer.ans_permant_abuse == 0 &&
                        
                        <div key={ai} className="answer-block" id={`answer_${ai + 1}`}>
                        {answer.ans_user_name == "Author of question" ?
                        
                        (<User user={answer} isAnonymus={0} eleRef={eleRef} />) :

                        (<a href={service.getRedirectUrl(`/user-profile/${answer.acid}`)}>
                            <User user={answer} isAnonymus={0} eleRef={eleRef} />
                        </a>)
                        }
                        <div className="experts-ans">
                            <span className="R14_61 amore" id={`moretext_${qna.question_id}_${answer.answer_id}`}><span className="R14_9e ans">A. </span>{answer.answer_details}</span>
                            {isShowReadMore &&
                                <div className="readmore_popup ans-readmore" data-id={`moretext_${qna.question_id}_${answer.answer_id}`}>
                                    <div className="readmorelink R14_link" onClick={(e) => actions.readMoreClick(e, `moretext_${qna.question_id}_${answer.answer_id}`)}>Read More</div>
                                </div>
                            }
                        </div>
                        <div className="like-ans R13_9e">
                            <div data-icon-font="&#xe009;" data-id="like" className={answer.ans_like && answer.ans_like != 'false' ? "icon like-icon is-active d-cursor" : "icon like-icon"} onClick={() => actions.saveAnsAction(answer.ans_like && answer.ans_like != 'false' ? 0 : 1, qna.question_id, answer.answer_id, "like", eleRef)}></div>
                            {answer.ans_like_count && parseInt(answer.ans_like_count) > 0 ?
                                <span className="like-count" onClick={() => actions.getAnswerLikeUsers(answer.ans_like_count, answer.answer_id)}>{answer.ans_like_count} {parseInt(answer.ans_like_count) > 1 ? 'Likes' : 'Like'}</span>
                                :
                                <span className="like-count"></span>
                            }
                            {isShowAbuse && answer.acid !== global.userAry['mycid'] &&
                                <span className={(answer.ans_abuse && (answer.ans_abuse == 1 || answer.ans_abuse != "false")) ? "ans_abuse right R13_9e is-active" : "ans_abuse right R13_9e"} title={(answer.ans_abuse && (answer.ans_abuse == 1 || answer.ans_abuse != "false")) ? "Already Reported as Abuse" : "Report Abuse"}>
                                <span data-icon-font="&#xe002;" className="icon icon3dot" onClick={(e) => actions.showAbuse(e)}></span>
                                {(answer.ans_abuse && (answer.ans_abuse == 1 || answer.ans_abuse != "false")) ?
                                    <div className="abuse-tooltip R13_9e">Already Reported as Abuse</div>
                                    :
                                    <div className="abuse-tooltip R13_9e" onClick={() => actions.saveAnsAction((answer.ans_abuse && (answer.ans_abuse == 1 || answer.ans_abuse != "false")) ? 0 : 1, qna.question_id, answer.answer_id, "abuse", eleRef)}>Report Abuse</div>
                                }
                            </span>
                            }
                        </div>
                    </div>
                        
                    )}
                </div>
            )}
        </div>
    );
}



// WEBPACK FOOTER //
// src/shared/qna/common/Question.js